import { render, staticRenderFns } from "./DashboardCommentsPartenaires.vue?vue&type=template&id=d115cfc2&"
import script from "./DashboardCommentsPartenaires.vue?vue&type=script&lang=js&"
export * from "./DashboardCommentsPartenaires.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCommentsPartenaires.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports